import React, { Component } from "react";
import commonUtil from "../../../../../../../utils/commonUtil";
import Barcode from "react-barcode";

class GiftRegistryIdModalOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Mi ID de mesa de regalos",
    };
  }

  componentDidMount() {
    this.setState({ title: "Mi ID de mesa de regalos" });
    document.body.classList.add('body-no-scroll');
  }

  render() {
    const { title } = this.state;
    return (
      <div id="gift-registry-id-modal-overlay" className="evnt_modal_overlay">
        <div className="modal-content-event">
          <div className="evnt-modal-header">
            <h4 className="modal-title">{title}</h4>
            <button
              className="close-button"
              onClick={this.props.hideModalOverlay}
              aria-label="Cerrar modal"
            >
              <img
                src={commonUtil.getAssetURL() + "/images/close.svg"}
                alt=""
                className="icon_vozcliente"
              />
            </button>
          </div>
          <div className="evnt_modal_body" onClick={(e) => e.stopPropagation()}>
            <div className="infoContainer">
              <div className="infoText largeText">
                El ID te permite realizar compras personales en tienda y
                abonarlas a tu mesa de regalos
              </div>
              <div className="barcodeContainer">
                <div className="barcodeBox">
                  <Barcode
                    value={this.props.ecardId || "0001956371982"}
                    format="CODE128"
                    width={2.3}
                    height={100}
                    fontSize={12}
                    textAlign="center"
                    displayValue={true}
                    textMargin={16}
                    font="Roboto"
                  />
                </div>
                <div className="barcodeNote">
                  *Este código de barras es exclusivo del festejado. No lo
                  compartas, es personal e intransferible.
                </div>
              </div>

              <div className="divider" />
              <div className="infoText smallText">
                *No olvides pedir a quien te atienda que escanee este código
                antes de pagar. Así se registrará tu compra.
              </div>
              <div className="infoText smallText">
                *Recuerda: no compres usando el número de evento, utiliza
                siempre el ID del festejado.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GiftRegistryIdModalOverlay;
